frappe.ready(function () {
	// Only run on the cart page
	if (!window.location.pathname || !window.location.pathname.startsWith("/cart")) {
		return;
	}

	var checkoutFlags = null;

	function removeMatchingElements(selectors) {
		selectors.forEach(function (selector) {
			var elements = document.querySelectorAll(selector);
			elements.forEach(function (element) {
				element.remove();
			});
		});
	}

	function renderPaymentModeSelector(flags) {
		var placeOrderContainer = document.querySelector(".cart-payment-addresses .place-order");
		if (!placeOrderContainer) {
			return;
		}

		var existing = document.getElementById("ce-payment-mode-selector");
		if (existing) {
			existing.remove();
		}

		if (flags.has_pending_checkout_order) {
			renderPendingOrderNotice(placeOrderContainer);
			return;
		}

		if (!flags.show_payment_mode_selector) {
			return;
		}

		var wrapper = document.createElement("div");
		wrapper.id = "ce-payment-mode-selector";
		wrapper.className = "mb-3";
		wrapper.innerHTML = [
			'<label class="form-label font-md" for="ce-payment-mode-input">Payment Method</label>',
			'<select class="form-control" id="ce-payment-mode-input">',
			flags.enable_prepaid ? '<option value="PREPAID">Pay Now</option>' : "",
			flags.enable_cod ? '<option value="COD">Cash on Delivery</option>' : "",
			"</select>",
			'<div class="text-muted mt-2" id="ce-payment-mode-note"></div>',
		].join("");

		placeOrderContainer.parentNode.insertBefore(wrapper, placeOrderContainer);

		var select = document.getElementById("ce-payment-mode-input");
		var note = document.getElementById("ce-payment-mode-note");
		select.value = flags.selected_payment_mode || flags.default_payment_mode || "PREPAID";
		updatePaymentModeNote(select.value, note);

		select.addEventListener("change", function () {
			var nextMode = select.value;
			frappe.call({
				method: "raftor_webhq.checkout.simple_checkout.set_checkout_payment_mode",
				args: { payment_mode: nextMode },
				callback: function (response) {
					var message = response && response.message ? response.message : {};
					checkoutFlags.selected_payment_mode = message.selected_payment_mode || nextMode;
					select.value = checkoutFlags.selected_payment_mode;
					updatePaymentModeNote(checkoutFlags.selected_payment_mode, note);
				},
			});
		});
	}

	// Once "Place Order" has been clicked, the payment mode select is gone and
	// the customer has no way back to it (see raftor_webhq.checkout.simple_checkout
	// .cancel_pending_checkout_order docstring). Offer an explicit way out
	// instead of a silent 30-minute wait for the passive cleanup job.
	function renderPendingOrderNotice(placeOrderContainer) {
		var wrapper = document.createElement("div");
		wrapper.id = "ce-payment-mode-selector";
		wrapper.className = "mb-3";
		wrapper.innerHTML = [
			'<div class="text-muted mb-2">You have a payment in progress for this order.</div>',
			'<button type="button" class="btn btn-outline-secondary btn-sm" id="ce-change-payment-method">',
			"Change payment method",
			"</button>",
		].join("");

		placeOrderContainer.parentNode.insertBefore(wrapper, placeOrderContainer);

		document.getElementById("ce-change-payment-method").addEventListener("click", function (evt) {
			var btn = evt.currentTarget;
			btn.disabled = true;
			frappe.call({
				method: "raftor_webhq.checkout.simple_checkout.cancel_pending_checkout_order",
				callback: function () {
					window.location.reload();
				},
				error: function () {
					btn.disabled = false;
				},
			});
		});
	}

	function updatePaymentModeNote(selectedMode, noteEl) {
		if (!noteEl) {
			return;
		}

		if (checkoutFlags && checkoutFlags.hide_payment_on_webshop) {
			noteEl.textContent = "Your order will be confirmed now using the default checkout settings.";
			return;
		}

		if (selectedMode === "COD") {
			noteEl.textContent = "Your order will be confirmed now and payment will be collected on delivery.";
			return;
		}

		noteEl.textContent = "You can place the order now and complete payment from the order page.";
	}

	frappe.call({
		method: "raftor_webhq.checkout.simple_checkout.get_simple_checkout_flags",
		freeze: false,
		callback: function (r) {
			if (!r || !r.message) return;

			var flags = r.message;
			checkoutFlags = flags;
			window.checkoutFlags = flags;
			renderPaymentModeSelector(flags);

			// Hide payment-related UI on the cart sidebar
			if (flags.hide_payment_on_webshop) {
				// Hide only the payment summary and coupon section.
				// Keep the Place Order button visible so checkout can complete.
				removeMatchingElements([
					".cart-payment-addresses .payment-summary",
					".cart-payment-addresses [data-section='payment-summary']",
				]);

				// Coupon section (if present)
				var couponButton = document.querySelector(".cart-payment-addresses .bt-coupon");
				if (couponButton && couponButton.parentElement) {
					// Remove the row containing coupon controls
					couponButton.parentElement.remove();
				}
			}

			// Hide shipping/billing address selection UI
			if (flags.hide_shipping_on_webshop) {
				removeMatchingElements([
					'[data-section="shipping-address"]',
					'[data-section="billing-address"]',
					".cart-payment-addresses .shipping-address",
					".cart-payment-addresses .billing-address",
				]);

				// Remove the "Billing Address is same as Shipping Address" checkbox row if present
				var sameBillingInput = document.getElementById("input_same_billing");
				if (sameBillingInput && sameBillingInput.closest('.checkbox')) {
					sameBillingInput.closest('.checkbox').remove();
				}
			}
		},
	});
});
